
export default function ProfileLoader() {
    return (
        <>
            <div className="card row  p-3 p-lg-4 me-lg-2">

                {/* Profile top row placeholder */}
                <div className="d-flex align-items-center mb-2">
                    <div
                        className="placeholder rounded-circle me-3"
                        style={{ width: '50px', height: '50px' }}
                    ></div>
                    <div className="col-12 col-md-6 mb-2">
                        <div className="placeholder-glow mb-1">
                            <span className="placeholder placeholder-sm col-8"></span>
                        </div>
                        <div className="col-4">
                            <div className="placeholder placeholder-xs rounded-pill w-100  " ></div>
                        </div>
                    </div>
                </div>

                {/* Contact Info placeholder */}
                <div className="row text-muted mb-0 mt-lg-0 mb-lg-1">
                    <div className="col-12 col-md-12 col-lg-6 mb-1 placeholder-glow">
                        <span className="placeholder placeholder-xs col-8"></span>
                    </div>
                    <div className="col-12 col-md-12 col-lg-6 mb-1 placeholder-glow">
                        <span className="placeholder placeholder-xs col-8"></span>
                    </div>
                </div>

                <hr />

                {/* Progress Section placeholder */}
                <div className="row">
                    <div className="col-12 col-md-6 mb-2">
                        <div className="placeholder-glow mb-1">
                            <span className="placeholder placeholder-xs col-6"></span>
                        </div>
                        <div className="placeholder placeholder-xs  w-100" ></div>
                    </div>

                    <div className="col-12 col-md-6 mb-2">
                        <div className="placeholder-glow mb-1">
                            <span className="placeholder placeholder-xs col-5"></span>
                        </div>
                        <div className="placeholder placeholder-xs   w-100" ></div>
                    </div>
                </div>
            </div>
        </>
    )
}